import { parsePhoneNumberFromString } from 'libphonenumber-js'

/** `tel:` URI for a phone number, formatted through libphonenumber when it parses */
export const phoneDialString = (phone: string): string =>
  parsePhoneNumberFromString(phone, 'FR')?.format('RFC3966') ??
  `tel:${phone.replace(/(?!^\+)[^\d]/g, '')}`

/** Whether a number can receive an SMS: it parses as a valid number */
export const isValidPhoneNumber = (phone?: string | null): phone is string =>
  typeof phone === 'string' &&
  (parsePhoneNumberFromString(phone, 'FR')?.isValid() ?? false)
